// 引入storre
import store from '../store'
import Vue from 'vue';
import Router from 'vue-router';
// import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/login/login';
import Home from '@/components/home/home';
import Index from '@/components/home/index';
// 公告管理
import PlatformList from '@/components/home/announcement/platform-list';
import SupplierList from '@/components/home/announcement/supplier-list';
// 货品管理
import GoodsList from '@/components/home/goods-management/goods-list';
import CombinedSalesBinding from '@/components/home/goods-management/combined-sales-binding';
import ChannelList from '@/components/home/goods-management/channel-list';
import ChannelInventoryEnquiry from '@/components/home/goods-management/channel-inventory-enquiry';
import GoodsNumInventoryEnquiry from '@/components/home/goods-management/goods-num-inventory-enquiry';
import CostPriceEnquiry from '@/components/home/goods-management/cost-price-enquiry';
import FreightQuery from '@/components/home/goods-management/freight-query';
import DefaultDeliveryLogistics from '@/components/home/goods-management/default-delivery-logistics/default-delivery-logistics';
import DuBidManagement from '@/components/home/goods-management/du-bid-management'
import ActivityLink from '@/components/home/goods-management/activity-link'
// 宝贝管理
import BabyManagement from '@/components/home/goods-management/baby-management/baby-management';
// 销售管理
import OrderList from '@/components/home/sales-management/order-list';
import OrderListCopy from '@/components/home/sales-management/order-list-copy';
import RetailOrder from '@/components/home/sales-management/retail-order';
import Car from '@/components/home/sales-management/car';
import AfterSalesApply from '@/components/home/sales-management/after-sales-apply';
import OrderImport from '@/components/home/sales-management/order-import';
import AfterSalesList from '@/components/home/sales-management/after-sales-list';
import AfterSalesDetail from '@/components/home/sales-management/after-sales-detail';
import SalesPriceMg from '@/components/home/sales-management/sales-price-mg';
// 资金管理
import AccountRecharge from '@/components/home/money-management/account-recharge';
import PaymentPassword from '@/components/home/money-management/payment-password';
import AccountManagement from '@/components/home/money-management/account-management';
import RechargeOrder from '@/components/home/money-management/recharge-order';
import ComplaintOrder from '@/components/home/money-management/complaint-order';
import CapitalFlow from '@/components/home/money-management/capital-flow';
// 报表管理
import ProprietaryCosts from '@/components/home/report-management/proprietary-costs';
import FinancialBilling from '@/components/home/report-management/financial-billing';
import GrossProfitRate from '@/components/home/report-management/gross-profit-rate';
// 系统基础
import SetupShop from '@/components/home/system-based/setup-shop';
import DataDownload from '@/components/home/system-based/data-download';
import SupplierBinding from '@/components/home/system-based/supplier-binding';
import UserSettings from '@/components/home/system-based/user-settings';
import RoleSettings from '@/components/home/system-based/role-settings';
// 登录超时
import LoginTimeout from '@/components/home/login-timeout';

Vue.use(Router);

// 页面刷新时，重新复制token
if (sessionStorage.getItem('token')) {
  store.commit('setToken', sessionStorage.getItem('token'));
}

export default new Router({
  // mode:'history',
  routes: [
    {
      path: '/',
      // redirect: '/',
      redirect: '/login',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      // name: 'home',
      redirect: '/home/p_list',
      component: Home,
      children: [
        { path: '/home/index', name: 'index', component: Index, meta: {keepAlive: true} },
        { path: '/home/p_list', name: 'platform-list', component: PlatformList, meta: {keepAlive: true} }, // keepAlive: true = 需要被缓存    false = 不需要被缓存
        { path: '/home/s_list', name: 'supplier-list', component: SupplierList, meta: {keepAlive: true} },
        { path: '/home/g_list', name: 'goods-list', component: GoodsList, meta: {keepAlive: true} },
        { path: '/home/cs_list', name: 'combined-sales-binding', component: CombinedSalesBinding, meta: {keepAlive: true} },
        { path: '/home/c_list', name: 'channel-list', component: ChannelList, meta: {keepAlive: true} },
        { path: '/home/ci_enquiry', name: 'channel-inventory-enquiry', component: ChannelInventoryEnquiry, meta: {keepAlive: true} },
        { path: '/home/gni_enquiry', name: 'goods-num-inventory-enquiry', component: GoodsNumInventoryEnquiry, meta: {keepAlive: true} },
        { path: '/home/cp_enquiry', name: 'cost-price-enquiry', component: CostPriceEnquiry, meta: {keepAlive: true} },
        { path: '/home/f_enquiry', name: 'freight-query', component: FreightQuery, meta: {keepAlive: true} },
        { path: '/home/d_logistics', name: 'default-delivery-logistics', component: DefaultDeliveryLogistics, meta: {keepAlive: true} },
        { path: '/home/du-bid-management', name: 'du-bid-management', component: DuBidManagement, meta: {keepAlive: true} },
        { path: '/home/activity-link', name: 'activity-link', component: ActivityLink, meta: {keepAlive: true} },
        { path: '/home/baby_mg', name: 'baby-management', component: BabyManagement, meta: {keepAlive: true} },
        { path: '/home/o_list', name: 'order-list', component: OrderList, meta: {keepAlive: true} },
        { path: '/home/o_list_copy', name: 'order-list-copy', component: OrderListCopy, meta: {keepAlive: true} },
        { path: '/home/r_order', name: 'retail-order', component: RetailOrder, meta: {keepAlive: true} },
        { path: '/home/car', name: 'car', component: Car, meta: {keepAlive: true} },
        { path: '/home/as_apply', name: 'after-sales-apply', component: AfterSalesApply, meta: {keepAlive: true} },
        { path: '/home/o_import', name: 'order-import', component: OrderImport, meta: {keepAlive: true} },
        { path: '/home/as_list', name: 'after-sales-list', component: AfterSalesList, meta: {keepAlive: true} },
        { path: '/home/as_list/after_detail', name: 'after-sales-detail', component: AfterSalesDetail, meta: {keepAlive: true} },
        { path: '/home/as_list/sales_price_mg', name: 'sales-price-mg', component: SalesPriceMg, meta: {keepAlive: true} },
        { path: '/home/a_recharge', name: 'account-recharge', component: AccountRecharge, meta: {keepAlive: true} },
        { path: '/home/pay_pwd', name: 'payment-password', component: PaymentPassword, meta: {keepAlive: true} },
        { path: '/home/a_mg', name: 'account-management', component: AccountManagement, meta: {keepAlive: true} },
        { path: '/home/recharge_order', name: 'recharge-order', component: RechargeOrder, meta: {keepAlive: true} },
        { path: '/home/complaint_order', name: 'complaint-order', component: ComplaintOrder, meta: {keepAlive: true} },
        { path: '/home/capital_flow', name: 'capital-flow', component: CapitalFlow, meta: {keepAlive: true} },
        { path: '/home/pc_report', name: 'proprietary-costs', component: ProprietaryCosts, meta: {keepAlive: true} },
        { path: '/home/f_billing', name: 'financial-billing', component: FinancialBilling, meta: {keepAlive: true} },
        { path: '/home/gpr_report', name: 'gross-profit-rate', component: GrossProfitRate, meta: {keepAlive: true} },
        { path: '/home/s_setup', name: 'setup-shop', component: SetupShop, meta: {keepAlive: true} },
        { path: '/home/s_download', name: 'data-download', component: DataDownload, meta: {keepAlive: true} },
        { path: '/home/s_binding', name: 'supplier-binding', component: SupplierBinding, meta: {keepAlive: true} },
        { path: '/home/u_setup', name: 'user-settings', component: UserSettings, meta: {keepAlive: true} },
        { path: '/home/r_setup', name: 'role-settings', component: RoleSettings, meta: {keepAlive: true} },
        { path: '/home/lto', name: 'login-timeout', component: LoginTimeout }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js